// extracted by mini-css-extract-plugin
export var content = "k_w";
export var icon = "k_Q";
export var text = "k_4";
export var wrapper = "k_3";